import { render, staticRenderFns } from "./MemberDetailGroups.vue?vue&type=template&id=4749f61a"
import script from "./MemberDetailGroups.vue?vue&type=script&lang=js"
export * from "./MemberDetailGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports